<template>
  <div class="home" id="home">
    <vue-headful title="Alarmierung - FF Pfaffenhofen"/>
    <Header :menu-at="0" headerTitle="Alarmierung"/>
    <div class="container header-container">
      <h1>Woher weiß die Feuerwehr, dass es brennt?</h1>
      <p>
        Manche glauben es noch, andere wissen es schon, die Feuerwehrleute sitzen nicht, wie in manchen Kinderbüchern behauptet, täglich im Feuerwehrhaus und spielt Karten, wartend auf den nächsten Einsatz.
      </p>
      <p>Doch woher wissen die Retter dann, wo es brennt oder ein Verkehrsunfall passierte? Wie schaffen sie es trotzdem die Hilfsfrist von 10 Minuten (wie hier in Bayern) einzuhalten?</p>
      <p>Hierbei hilft wieder die heutige Technik. Zum einen werden die Feuerwehrfrauen und -männer über die örtlichen Sirenen alarmiert. Bei kleinen Einsätzen oder auch in größeren Städten wird "still" alarmiert. Die "stille Alarmierung" läuft über Funkmeldeempfänger ab. Die Feuerwehreinsatzzentrale sendet über Funk den Alarm an die einzelnen Feuerwehrleute. Jeder Feuerwehrangehörige hat das kleine Gerät immer bei sich zu tragen. Der Alarm erreicht ihn also überall, im Kaufhaus beim Shoppen, beim Mittagessen zu Hause, nachts im Schlaf oder am Arbeitsplatz.</p>
      <p>Der Piepston des Funkmeldeempfängers ist sehr laut und somit eigentlich nicht zu überhören. Danach erfolgt eine Durchsage mit der Einsatzmeldung.</p>
      <p>Neben der Alarmierung mittels Funk gibt es jetzt auch die SMS-Alarmierung. Jeder Feuerwehrmann bekommt also eine SMS im Einsatzfall. Der Hauptalarmierungsweg ist aber immer noch via Funk. Denn das Handynetz (gerade an Sylvester) kann schnell überlastet sein.</p>
      <p>Nach dem Alarm begibt sich der Feuerwehrmann ins Feuerwehrgerätehaus. Hierfür benötigt er je nach Entfernung 2 bis 5 Minuten. Im Feuerwehrhaus zieht er seine Schutzkleidung über und ist in der Regel nach höchstens 1 Minute fertig angezogen auf dem Fahrzeug!</p>
    </div>
    <div class="overview">
      <div class="border"></div>
      <div class="container overview-container">
        <div class="flex-row">
          <div class="vehicle-card">
            <img src="/alarm/0.jpg">
            <p>Ein typischer Funkmeldeempfänger.</p>
          </div>
          <div class="vehicle-card">
            <img src="/alarm/1.jpg" @click="showTlfModal()">
            <p>Immer mehr verbreitet: der Alarm via SMS.</p>
          </div>
        </div>
      </div>
      <div class="border"></div>
    </div>

    <div class="text">
      <div class="container text-container">
        <h1>Sirenensignale</h1>
        <p>Die Feuerwehr wird nicht nur über Funkmeldeempfängern alarmiert. Bei größeren Schadenslage wird zusätzlich noch die Alarmierung mittels Sirene durchgeführt.</p>
        <p>Es gibt zwei verschiedene Sirenentöne:</p>
        <p><b>1 Minute Dauerton, zweimal unterbrochen</b></p>
        <p>Verhaltensregeln:</p>
        <ul>
          <li>Achten Sie als Verkehrsteilnehmer jetzt besonders auf Fahrzeuge mit Blaulicht und Martinshorn.</li>
          <li>Die Hilfsorganisationen sind auf freie Verkehrswege angewiesen.</li>
        </ul>
        <p>Besteht die Notwendigkeit, bei größeren Schadensereignissen wie zum Beispiel Unglücksfällen oder Katastrophenlagen die Bevölkerung zu warnen, werden neben Lautsprecherdurchsagen von Feuerwehr und Polizei auch die Sirenen der Gemeinden eingesetzt. Über Rundfunk- und Lautsprecherdurchsagen erhalten Sie entsprechende Information und Verhaltensregeln.</p>
        <p>Der Heulton soll die Bevölkerung bei schwerwiegenden Gefahren für die öffentliche Sicherheit veranlassen, ihre Rundfunkgeräte einzuschalten und auf Durchsagen zu achten.</p>
        <p><b>1 Minute Heulton, an- und abschwellend</b></p>
        <ul>
          <li>Achten Sie auf Rundfunkdurchsagen  und Lautsprecherdurchsagen.</li>
          <li>Verständigen Sie Nachbarn und ausländische Mitbürger.</li>
        </ul>
      </div>
    </div>  
    
    <div class="overview">
      <div class="border"></div>
      <div class="container overview-container">
        <div class="flex-row">
          <div class="vehicle-card">
            <img src="/alarm/2.jpg">
            <p>Die Sirene auf dem Dach des Pfaffenhofner Gerätehaus.</p>
          </div>
        </div>
      </div>
    </div>

    <Footer />
    <Scroll2Top />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Scroll2Top from '@/components/Scroll2Top.vue'

export default {
  name: 'home',
  components: {
    Header, Footer, Scroll2Top
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/theme.scss";

.header-container {
  padding-top: 100px;
}


h1 {
  text-align: center;

  @include tablet {
    text-align: left;
  }
}

p {
  opacity: 0.8;
}

.border {
  border-top: 2px solid $light-0;
}

.overview {
  background: $dark;
  padding: 6px 0px;

  h1, h2, p {
    color: $light-0;
  }
}

.flex-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  margin-top: 40px;
  margin-bottom: 20px;
  align-items: center;
}

.vehicle-card {
  margin-bottom: 0px;
  width: 320px;

  img {
    width: 320px;
    object-fit: cover;
  }

  P {
    margin-top: 0px;
    padding: 0px 10px; 
    text-align: center;
  }
}

.more-text {
  margin: 20px 0px;
}


</style>
